module.exports = "'data:image/svg+xml;utf8,<svg width=\"20\" height=\"19\" viewBox=\"0 0 20 19\" xmlns=\"http://www.w3.org/2000/svg\"><title>Slice 1</title><path d=\"M2 17V0H0v19h20v-2H2z\" fill=\"%23D4DAE8\" fill-rule=\"evenodd\"/></svg>'"


/*****************
 ** WEBPACK FOOTER
 ** ./src/InheritanceTree/node.svg
 ** module id = 1414
 ** module chunks = 0
 **/